import { useSelector } from "react-redux";
import { IRootState } from "../redux/reducers/root";

export function useAppSelector<TSelected>(
    selector: (state: IRootState) => TSelected,
    equalityFn?: (left: TSelected, right: TSelected) => boolean
) {
    return useSelector(selector, equalityFn);
}
